import { keepPreviousData, useInfiniteQuery } from '@tanstack/react-query';
import { NotificationApiV2 } from 'Data/Notification.api.v2';
import { INewNotificationsFilters } from 'Data/interfaces/Notification/INotification';
import { NOTIFICATIONS_PAGE_QUERY_KEY } from 'Data/keys/QueryKeys';

export const useQueryNotifications = (
  pageInfinityNotificationsSize: number = 10,
  filters?: INewNotificationsFilters,
) => {
  const {
    data,
    hasNextPage,
    isFetchingNextPage,
    isRefetching,
    isLoading,
    error,
    refetch,
    fetchNextPage,
  } = useInfiniteQuery({
    queryKey: [NOTIFICATIONS_PAGE_QUERY_KEY, filters ?? {}],
    initialPageParam: 1,
    staleTime: 60 * 5 * 1000, // 5 minutes
    placeholderData: keepPreviousData,
    queryFn: async ({ pageParam }) => {
      const response = await NotificationApiV2.listNotifications({
        pageNumber: pageParam,
        pageSize: pageInfinityNotificationsSize,
        filters,
      });
      return { notifications: response.data.data, info: response.data.info };
    },
    getNextPageParam: (last) => {
      if (last.info.nextPageNumber && last.notifications.length > 0) {
        return last.info.nextPageNumber;
      }
      return undefined;
    },
  });

  return {
    data: data?.pages.flatMap((page) => page.notifications) ?? [],
    isLoading,
    isRefetching,
    error,
    hasNextPage,
    isFetchingNextPage,
    refetch,
    fetchNextPage,
  };
};
